<template>

  <div id="page-user-list">
    <div class="vx-card p-6">

      <div class="flex flex-wrap items-center">
        
        <table border="1">
<tr>
  <td style="padding: 5px;"><b>Instructor Name: </b></td>
  <td style="padding: 5px;">
    {{ teacher_name }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Student Name: </b></td>
  <td style="padding: 5px;">
    {{ student_name }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Review Text: </b></td>
  <td style="padding: 5px;">
    {{ review_text }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Meeting Tim: </b></td>
  <td style="padding: 5px;">
    {{ review1 }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Patient: </b></td>
  <td style="padding: 5px;">
    {{ review2 }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>The Car: </b></td>
  <td style="padding: 5px;">
    {{ review3 }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Focus </b></td>
  <td style="padding: 5px;">
    {{ review4 }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Is Complaint? </b></td>
  <td style="padding: 5px;">
    {{ is_complaint }}
  </td>
</tr>
<tr>
  <td style="padding: 5px;"><b>Date: </b></td>
  <td style="padding: 5px;">
    {{ date }}
  </td>
</tr>   
</table>
  

      </div>

        
    </div>
  </div>

</template>

<script>

import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'


// Store Module
import moduleLessonsRatingManagement from '@/store/lessons-rating/moduleLessonsRatingManagement.js'



export default {
  components: {
    
  },
  data() {
    return {

      teacher_name: '',
      student_name: '',
      review_text: '',
      review1: '',
      review2: '',
      review3: '',
      date: '',
      review4: '',
      is_complaint: ''

    }
  },
  watch: {
    
  },
  computed: {
    
    
  },
  methods: {
  },
  mounted() {
  },
  created() {
    
    if(!moduleLessonsRatingManagement.isRegistered) {
        console.log('is registered not');
      this.$store.registerModule('lessonsratingManagement', moduleLessonsRatingManagement)
      moduleLessonsRatingManagement.isRegistered = true
    }

    this.$store.dispatch("lessonsratingManagement/fetchRatings", {
      id: this.$route.params.ratingId
    })
      .then(res => { 
          this.teacher_name = res.data[0].teacher.name + ' ' + res.data[0].teacher.last_name
          this.student_name = res.data[0].student.name + ' ' + res.data[0].student.last_name
          this.review_text = res.data[0].review

          this.review1 = res.data[0].rating1
          this.review2 = res.data[0].rating2
          this.review3 = res.data[0].rating3
          this.date = res.data[0].created_at
          this.review4 = res.data[0].rating4
          this.is_complaint = (res.data[0].is_complaint === 1) ? 'Yes' : 'No'
          
          //this.learning_video_seen = res.data[0].learning_video_seen

        })
      .catch(err => {
        
        console.error(err) }
    )

  }
}

</script>



<style type="text/css">

.pagidropdown{
    padding: 11px!important;
}

.rounded-full {
    border-radius: 7px !important;
}

.teacherSearchBtn{
  width: 34% ! important;
}

.teacherSearchStatus{
  width: 17% ! important;
}

.teacherSearchEmail{
  width: 17% ! important;
}
</style>